export const infoTooltipMsg =
  'Validity period of step-up verification after which the user is re-verified.'
export const mfaSettingsInfo = 'For Login and Step-up verification.'

export const mfaOptions = {
  WEB_AUTHN: 'WEB_AUTHN',
  TOTP: 'TOTP',
}

export const mfaOptionsValues = {
  ALLOWED: 'ALLOWED',
  NOT_ALLOWED: 'NOT_ALLOWED',
}
